import SearchService from "services/search-service";
import DownloadService from "services/download-service";
import UserService from "services/user-service";

export const facebookLoginHandler = (resolve, reject) => {
  if (window.FB) {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          console.log("Logged in with Facebook:", response);
          checkLoginState(resolve, reject);
        } else {
          console.log("User cancelled login or did not fully authorize.");
          reject(new Error("Login cancelled or not authorized."));
        }
      },
      { scope: "public_profile,email,pages_show_list,pages_read_engagement" }
    );
  } else {
    console.error("Facebook SDK not loaded");
    reject(new Error("Facebook SDK not loaded"));
  }
};

const checkLoginState = (resolve, reject) => {
  window.FB.getLoginStatus(async (response) => {
    try {
      await statusChangeCallback(response);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

const statusChangeCallback = async (response) => {
  if (response.status === "connected") {
    const fbSLAT = response.authResponse.accessToken;
    localStorage.setItem("fbSLAT", fbSLAT);

    const searchTerm = "Dummy"; // Example search term
    const platform = "Facebook";
    const combinedResults = await SearchService.searchAllPlatforms(searchTerm, platform);

    if (combinedResults && combinedResults.length > 0) {
      for (const result of combinedResults) {
        try {

          const profileData = {
            id: result.id,
            platform: result.platform,
            name: result.name,
            count: result.followers_count || result.subscribersCount,
            creationDate: result.creationDate,
            profilePictureUrl: result.picture,
            link: result.link,
            verifiedStatus:
              result.verification_status === "verified" ||
              result.verification_status === "blue_verified",
            own: true,
          };

          // Download profile using the DownloadService
          await DownloadService.downloadProfile(result.platform, { profileData });
          console.log(`Successfully downloaded profile: ${result.name}`);
          localStorage.removeItem("fbSLAT");
        } catch (error) {
          console.error(`Error downloading profile (${result.name}):`, error.message);
        }
      }
    } else {
      console.log("No results found in combinedResults.");
      reject(new Error("No Facebook Pages found. Please check your permissions and ensure you have selected a page to connect."));
    }
  } else {
    console.log("User not authenticated");
  }
};

// import OAuthService from "services/oauth-service";

// // Define the scopes required for Facebook
// const SCOPES = "public_profile,email,instagram_basic,instagram_manage_insights";

// export const facebookLoginHandler = async (resolve, reject) => {
//   try {
//     // Use the OAuth service to initiate Facebook login
//     console.log("Initiating Facebook login...");
//     OAuthService.initiateOAuthLogin("facebook");
//     resolve(); // Resolve immediately after the redirect is initiated
//   } catch (error) {
//     console.error("Error during Facebook login:", error.message);
//     reject(error); // Reject the promise if there is an error
//   }
// };

